import { useAuth } from 'context/AuthProvider.js';
import { ApiEndpoint } from 'helpers/ApiEndPoint.js';
import { httpClient } from 'helpers/HttpClient.js';
import MyModal from 'helpers/MyModal.js';
import React, { useEffect, useState } from 'react';
import ClasificacionesQuejaWmTable from './_ClasificacionesQuejaTableWm.js';
import EditClasificacionQuejaWm from './_EditClasificacionQuejaWm.js';

const URI = ApiEndpoint + 'administration/';
const ClasificacionesQuejaWm = () => {
  const Auth = useAuth();
  var userData = Auth.getSessionData();
  const [openModal, setOpenModal] = useState(false);
  const [clasificacionesQueja, setClasificacionesQueja] = useState(false);

  const [idClasificacionQuejaEdit, setIdClasificacionQuejaEdit] =
    useState(false);
  const handleClose = () => {
    setOpenModal(false);
    getClasificacionesQueja();
  };

  const getClasificacionesQueja = async () => {
    console.log('entre a getClasificacionesQuejawm');
    setClasificacionesQueja(null);

    httpClient('GET', URI + 'clasificationswm/', {}, userData.token)
      .then(function (response) {
        if (!response.data.error) {
          setClasificacionesQueja(response.data);
        }
      })
      .catch(function (error) {
        console.log(error);
      })
      .finally(() => {});
  };
  useEffect(() => {
    getClasificacionesQueja();
  }, []);

  return (
    <>
      {clasificacionesQueja && (
        <ClasificacionesQuejaWmTable
          clasificacionesQueja={clasificacionesQueja}
          setIdClasificacionesQuejaToEdit={setIdClasificacionQuejaEdit}
          setOpenModal={setOpenModal}
        ></ClasificacionesQuejaWmTable>
      )}
      {openModal && (
        <MyModal
          id="id_myModal"
          title={
            (idClasificacionQuejaEdit > 0 ? 'Editar' : 'Agregar') +
            ' Clasificacion'
          }
          openModal={openModal}
          closeModal={handleClose}
        >
          <EditClasificacionQuejaWm
            idClasificacionQueja={idClasificacionQuejaEdit}
            closeModal={handleClose}
          ></EditClasificacionQuejaWm>
        </MyModal>
      )}
    </>
  );
};

export default ClasificacionesQuejaWm;
